import BaseDataObject from './BaseDataObject';
import Money from './Money';
import ShoeInfo from './ShoeInfo';
import SulkyInfo from './SulkyInfo';

// ---------------------------------------- GameInformation ----------------------------------------

export default class GameInformation extends BaseDataObject {
  getTimestamp() {
    return this.getDate('timestamp');
  }

  setTimestamp(v) {
    return this.setDate('timestamp', v);
  }

  getRows() {
    return this.getObjects('rows', GameRow);
  }

  getRow(index) {
    return this.getObject('rows', GameRow, index);
  }

  getNumberOfRows() {
    return this.getNumberOf('rows');
  }

  addRow(data) {
    return this.addObject('rows', GameRow, data);
  }

  hasOdds() {
    return this.getBoolean('hasOdds');
  }

  setHasOdds(value) {
    return this.setBoolean('hasOdds', value);
  }

  setDividendPerHorse(v) {
    this.setObject('dividendPerHorse', v);
  }

  getDividendPerHorse() {
    return this.getObject('dividendPerHorse', DividendPerHorse);
  }

  setDividendPerHorsePerLeg(v) {
    this.setObjects('dividendPerHorsePerLeg', v);
  }

  getDividendPerHorseForLeg(legNumber) {
    const dividendPerHorsePerLeg = this.getObjects(
      'dividendPerHorsePerLeg',
      DividendPerHorse,
    );
    return dividendPerHorsePerLeg.find(
      dividendPerHorse => dividendPerHorse.getLegNumber() === legNumber,
    );
  }

  getTurnover() {
    return this.getObject('turnover', Money);
  }

  setTurnover(v) {
    return this.setObject('turnover', v);
  }
}

// ---------------------------------------- GameRow ----------------------------------------

class GameRow extends BaseDataObject {
  isScratched(position) {
    return this.getBooleanAt('scratched', position);
  }

  setScratched(position, v) {
    return this.setBooleanAt('scratched', position, v);
  }

  getMarkPercent(position) {
    return this.getFloatAt('markPercent', position);
  }

  setMarkPercent(position, v) {
    return this.setFloatAt('markPercent', position, v);
  }

  getOdds(position) {
    return this.getIntegerAt('odds', position);
  }

  setOdds(position, v) {
    return this.setIntegerAt('odds', position, v);
  }

  getTrioIndex(position) {
    return this.getIntegerAt('trioIndex', position);
  }

  setTrioIndex(position, v) {
    return this.setIntegerAt('trioIndex', position, v);
  }

  getShoeInfo(position) {
    return this.getObject('shoeInfo', ShoeInfo, position);
  }

  setShoeInfo(position, v) {
    return this.setObject('shoeInfo', v, position);
  }

  getWinnerTurnover() {
    return this.getObject('winnerTurnover', Money);
  }

  setWinnerTurnover(v) {
    return this.setObject('winnerTurnover', v);
  }

  getSulkyInfo(position) {
    return this.getObject('sulkyInfo', SulkyInfo, position);
  }

  setSulkyInfo(position, v) {
    return this.setObject('sulkyInfo', v, position);
  }

  getIsFirstStart(position) {
    return this.getBooleanAt('isFirstStart', position, false);
  }

  setIsFirstStart(position, v) {
    return this.setBooleanAt('isFirstStart', position, v);
  }
}

// ---------------------------------------- GameRow ----------------------------------------

class DividendPerHorse extends BaseDataObject {
  getLegNumber() {
    return this.getInteger('legNumber');
  }

  getNumberOfDividends() {
    return this.getNumberOf('dividends');
  }

  getDividendForHorse(n) {
    return this.getObject('dividends', Money, n);
  }
}
